/**
 * Created by xiaoconghu on 2018/12/7.
 */

export enum TableStylePixel {
  PIXEL = 'px',
  TH_TAG_NAME = 'TH'
}
